import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import LenisProvider from "@/lib/lenis";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";

import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import Plan from "@/pages/Plan";
import Apply from "@/pages/Apply";
import Prepare from "@/pages/Prepare";
import Thrive from "@/pages/Thrive";
import Advisor from "@/pages/Advisor";
import PlanBuilder from "@/pages/PlanBuilder";
import Pricing from "@/pages/Pricing";
import Calculator from "@/pages/Calculator";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/prepare" element={<Prepare />} />
          <Route path="/thrive" element={<Thrive />} />
          <Route path="/advisor" element={<Advisor />} />
          <Route path="/plan-builder" element={<PlanBuilder />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </main>
      <Footer />
      <FloatingContact />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LenisProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#f5f1e8] text-[#0d1b3e]">
            <div className="grain" aria-hidden="true" />
            <AppRouter />
            <Toaster position="bottom-right" richColors closeButton />
          </div>
        </BrowserRouter>
      </LenisProvider>
    </AuthProvider>
  );
}
